import { render, staticRenderFns } from "./correspondence.vue?vue&type=template&id=154e2f6f&scoped=true&"
import script from "./correspondence.vue?vue&type=script&lang=js&"
export * from "./correspondence.vue?vue&type=script&lang=js&"
import style0 from "./correspondence.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./correspondence.vue?vue&type=style&index=1&id=154e2f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e2f6f",
  null
  
)

export default component.exports